<template>
  <div>
    <page-header :actions="headerActionConfig" :page="page" />

    <filter-manager
      ref="filterComponent"
      v-model="selectedFilters"
      class="mb-4 c-filterManager"
      :display-advanced="false"
      :filters="filtersConfig"
      @search="onSearchHandler"
    />

    <separator class="my-3" text="Resultado de Vigencia de Referido" />
    <search-result
      :result-search="result"
      :search-academic-year-id="searchedAcademicYear"
      @on-page-change="onPageChange"
    />
  </div>
</template>

<script>
import SearchResult from './SearchResult';
import alert from '@/mixins/alert.mixin';
import ServiceTypes from '@/utils/shared/constants/serviceTypes';
import { getAcademicYearsToCurrentYear } from '@/modules/shared/academicyear.api';
import { getDisciplineTypes } from '@/modules/shared/code.api';
import {
  compensatoryreferralSearch as _compensatoryreferralSearch,
  saveAdmission as _saveAdmission,
} from '@/modules/compensatoryService/api';

export default {
  name: 'ReferralValiditySearch',
  components: {
    SearchResult,
  },
  mixins: [alert],
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Vigencias de Referido',
        routes: ['Inicio', 'Proveedor', 'Vigencias de Referido'],
      },
      filters: {
        academicYears: [],
        disciplineTypes: [],
      },
      selectedFilters: {},
      result: {
        data: [],
        pagination: {
          currentPage: 1,
          totalItemCount: 0,
          pageCount: 0,
          count: 0,
          perPage: 10,
        },
      },
      dataCallOutSelected: [],
      searchedAcademicYear: null,
    };
  },
  computed: {
    filtersConfig() {
      let filters = [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filters.academicYears,
          placeholder: 'Seleccione Año Fiscal',
          fieldName: 'description',
          fieldKey: 'id',
          clearable: false,
          class: 'col-md-3',
          validations:
            !this.selectedFilters.academicYear ||
            this.selectedFilters.academicYear.id < 1
              ? 'required'
              : '',
          error: 'Es requerido seleccionar un año fiscal.',
        },
        {
          name: 'service',
          component: 'CustomDropDown',
          options: this.filters.disciplineTypes,
          placeholder: 'Seleccione Servicio',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: false,
          class: 'col-md-3',
          validations:
            !this.selectedFilters.service || this.selectedFilters.service.id < 1
              ? 'required'
              : '',
          error: 'Es requerido seleccionar un servicio.',
        },
        {
          name: 'sieNumber',
          component: 'CustomInput',
          placeholder: 'Escribir Número de SIE',
          leftIcon: true,
          icon: 'fas fa-search color-primary-2',
          validations:
            !this.selectedFilters.sieNumber ||
            !this.selectedFilters.sieNumber.trim()
              ? 'required'
              : '',
          error: 'Es requerido ingresar un número de SIE.',
        },
      ];
      return filters;
    },
    headerActionConfig() {
      return [
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          click: this.onSaveHandler,
          visible: this.result.data.length > 0,
        },
      ];
    },
    hasResultError() {
      return (
        this.result.data.filter((x) => {
          return (
            x.calloutData.filter(
              (c) =>
                c.startDateError ||
                c.endDateError ||
                c.dateStartRangeError ||
                c.dateEndRangeError
            ).length > 0
          );
        }).length > 0
      );
    },
  },
  mounted() {
    this.loadAcademicYears();
    this.loadServices();
  },
  methods: {
    async loadAcademicYears() {
      const { data } = await getAcademicYearsToCurrentYear();
      this.filters.academicYears = data;
    },
    async loadServices() {
      const therapyValidForFlag = 2;

      const { data } = await getDisciplineTypes(
        ServiceTypes.Therapy,
        therapyValidForFlag
      );
      this.filters.disciplineTypes = data;
    },
    async onSearchHandler(model, newPage) {
      const isValid = await this.$refs.filterComponent.$refs.formValidator.validate();
      if (!isValid) return;

      let currentPage = newPage ?? 1;
      let filter = {
        academicYearId: this.selectedFilters.academicYear.id,
        disciplineTypeId: this.selectedFilters.service.id,
        studentSieId: this.selectedFilters.sieNumber,
      };

      let self = this;

      await _compensatoryreferralSearch(
        filter,
        this.result.pagination.perPage,
        currentPage
      ).then((res) => {
        var data = res.data.data;
        self.result.data = self.transform(data);
        self.result.pagination.currentPage = res.data.currentPage;
        self.result.pagination.totalItemCount = res.data.totalItemCount;
        self.result.pagination.pageCount = res.data.pageCount;
        self.result.pagination.count = res.data.count;
        this.searchedAcademicYear = this.selectedFilters.academicYear?.id;
      });
    },
    transform(data) {
      let result = data.map((item) => {
        let boardData = [
          [
            {
              mainIcon: true,
              data: item.referralNumber,
              icon: 'fas fa-file-invoice',
              containerClass: 'mt-3',
              dataClass: 'font-16 color-black font-weight-bold ml-2',
              iconClass: 'font-20',
              cols: 'col-md-3 col-sm-12',
            },
            {
              label: 'Estudiante:',
              icon: 'fas fa-address-book',
              data: item.student,
              cols: 'col-md-3 col-sm-12',
            },
            {
              label: 'Modalidad:',
              icon: 'fas fa-address-book',
              data: item.modalityTypeName,
              cols: 'col-md-2 col-sm-12',
            },
            {
              label: 'Frecuencia:',
              icon: 'fas fa-address-book',
              data: item.frequencyTypeName,
              cols: 'col-md-2 col-sm-12',
            },
            {
              label: 'Duración:',
              icon: 'fas fa-address-book',
              data: item.durationTypeName,
              cols: 'col-md-2 col-sm-12',
            },
          ],
        ];

        let calloutData = item.referralAdmissions.map((referral) => {
          return {
            ...referral,
            referralNumber: referral.referralNumber,
            statusId: referral.admissionStatusId,
            status: referral.admissionStatusName,
            number: referral.admissionId,
            type: referral.admissionManagementRequestDropReason,
            date: referral.admissionManagementRequestDate,
            startDate: referral.effectiveDateFrom,
            endDate: referral.effectiveDateTo,
            isOpen: false,
            errors: [],
          };
        });

        let mapped = {
          boardData: boardData,
          calloutData: calloutData,
        };
        return mapped;
      });

      return result;
    },
    onPageChange(page) {
      this.result.pagination.currentPage = page;
      this.onSearchHandler(null, this.result.pagination.currentPage);
    },
    getMapResult(arr) {
      const result = [];
      for (let parent of arr) {
        for (let child of parent.calloutData) {
          if (child.changed) {
            result.push({
              studentServiceId: child.studentServiceId,
              admissionId: child.admissionId,
              effectiveDateFrom: new Date(child.startDate),
              EffectiveDateTo: new Date(child.endDate),
            });
          }
        }
      }
      return result;
    },
    setValidationError(errors) {
      this.result = {
        ...this.result,
        data: this.result.data.map((x) => {
          for (let err of errors) {
            x.calloutData = x.calloutData.map((c) => {
              if (err.admissionId === c.admissionId) {
                // c.errors = [
                //   ...c.errors,
                //   ...err
                // ]
                c.errors.push(err.errorMessage);
              }
              return c;
            });
          }
          return x;
        }),
      };
      this.$forceUpdate();
    },
    async onSaveHandler() {
      //validate empty dates
      this.result = {
        ...this.result,
        data: this.result.data.map((x) => {
          x.calloutData = x.calloutData.map((c) => {
            c.errors = [];
            c.startDateError = !c.startDate ?? false;
            c.endDateError = !c.endDate ?? false;

            //validated date range
            if (c.startDate && c.endDate) {
              if (c.changeStartDate) {
                c.dateStartRangeError =
                  new Date(c.endDate) < new Date(c.startDate);
              }
              if (c.changeEndDate) {
                c.dateEndRangeError =
                  new Date(c.startDate) > new Date(c.endDate);
              }
            }
            return c;
          });
          return x;
        }),
      };
      if (this.hasResultError) {
        this.ShowToast(
          'Alerta',
          'Favor completar información para poder guardar.',
          'error'
        );
        return;
      }

      const resultMapper = this.getMapResult(this.result.data);
      if (resultMapper.length > 0) {
        const { data } = await _saveAdmission(resultMapper).catch((err) => {
          this.ShowToast('Error', err.response.data.message, 'error');
        });
        if (data) {
          if (data?.length > 0) {
            this.ShowToast(
              'Error',
              'Se encontraron errores al guardar los datos',
              'error'
            );
            this.setValidationError(data);
            return;
          }
          this.ShowToast(
            'Proceso exitoso',
            'Los datos fueron guardados exitosamente.',
            'success'
          );
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.c-filterManager {
  ::v-deep button.success {
    @media only screen and (max-width: 600px) {
      width: 100%;
      margin: 0 19px 0 19px !important;
      //margin-left: 19px!important;
    }
  }
}
</style>
